const validation = {
  required: '{{field}} is verplicht',
  invalid: '{{field}} ongeldig',
  invalid_format: '{{field}} heeft een ongeldig formaat',
  invalid_format_example: '{{field}} heeft een ongeldig formaat. Bijv: {{example}}',
  min_length: '{{field}} moet minimaal {{min}} karakters bevatten',
  max_length: '{{field}} mag maximaal {{max}} karakters bevatten',

  // Dutch-specific
  invalid_postal_code: 'Postcode ongeldig (bijv: 1234AB)',
  invalid_kvk_number: 'KVK nummer moet 8 cijfers bevatten',
  invalid_btw_id: 'BTW-ID ongeldig (bijv: NL123456789B01)',
  invalid_vat_number: 'BTW-ID ongeldig voor dit land',
  invalid_email: 'E-mailadres heeft een ongeldig formaat',
  invalid_iban: 'IBAN ongeldig',

  // Numeric
  hourly_rate_negative: 'Uurprijs kan niet negatief zijn',
  hourly_rate_integer: 'Uurprijs moet een geheel getal zijn',

  // Password
  password_min_length: 'Wachtwoord moet minimaal 8 tekens bevatten',
  password_uppercase_required: 'Wachtwoord moet minimaal één hoofdletter bevatten',
  password_lowercase_required: 'Wachtwoord moet minimaal één kleine letter bevatten',
  password_number_required: 'Wachtwoord moet minimaal één cijfer bevatten',
  password_complexity:
    'Wachtwoord moet minimaal 8 tekens, één hoofdletter, één kleine letter en één cijfer bevatten',
  passwords_must_match: 'De wachtwoorden komen niet overeen',

  // Document lines
  document_line_label_max_length: 'Het label mag niet meer dan 255 tekens bevatten.',
  document_line_description_max_length: 'De beschrijving mag niet meer dan 2.000 tekens bevatten.',
}

export default validation
